import DonationServiceContextProvider from "../../../context/donation-service/provider";
import PageDetails from "../../general/details";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect } from "react";
import DonationServiceContext from "../../../context/donation-service/context";
import AppContext from "../../../context/app/context";
import Spin from "../../general/antd/spin";
import Descriptions from "../../general/antd/descriptions";
import { Descriptions as AntdDescriptions, Tag } from "antd";
import OldImage from "../../form-components/old-image";
import { getDonationServiceTypeByNumBer } from "../../../models/donation-service/enum";

interface Props {
}

const DonationServiceDetails: React.FC<Props> = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();
    const { details, actions, loading } = useContext(DonationServiceContext);
    const { direction } = useContext(AppContext);
    useEffect(() => {
        const getDetails = async () => {
            id && (await actions.getDetails(Number(id)));
        };
        getDetails();
    }, [direction]);

    return (
        <PageDetails
            title={t("details")}
            subtitle={t("charities_manager")}
            buttonName={`${t("update_DonationService")}`}
            onClick={() => navigate(`/donation-service/update/${id}`)}
        >
            {loading.includes("details") ? (
                <Spin />
            ) : (
                <Descriptions size="small" column={1} bordered>
                    <AntdDescriptions.Item label={t("id")}>
                        {details?.id}
                    </AntdDescriptions.Item>

                    <AntdDescriptions.Item label={t("name")}>
                        {details?.name}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("services")}>
                        
                        {details?.relatedServices?.length > 0
                            ? details?.relatedServices?.map((relatedService) => {
                                return <Tag>{relatedService.name}</Tag>;
                            })
                            : "-"}

                    </AntdDescriptions.Item>

                    <AntdDescriptions.Item label={t("type")}>
                            {getDonationServiceTypeByNumBer(Number(details?.type))}
                    </AntdDescriptions.Item>

                    <AntdDescriptions.Item label={t("description")}>
                        {details?.description ?? "-"}
                    </AntdDescriptions.Item>

                </Descriptions>
            )}
        </PageDetails>

    )

    // firstName: string;
    // lastName: string;
    // imageId: number;
    // coverId: number;
    // mobile: string;
    // note: ITranslationRequest;

    // gender: number;
    // address: string;
    // healthStatus: number;
    // DonationServiceStatus: number;
    // parentalInformation: number;

    // sponsorshipCost: number;

    // isStudent: boolean;

    // birthDate: Date;

    // nationalIdentityNumber: string;

    // cityId: number;
}

const DonationServiceDetailsPage = () => {
    return (
        <DonationServiceContextProvider>
            <DonationServiceDetails />
        </DonationServiceContextProvider>
    );
};
export default DonationServiceDetailsPage;